import { useEffect, useMemo, useState } from 'react'

import { HomeExpertProps } from './HomeExpert'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { basePath } from 'interfaces/constants'
import { ExpertAvatarItem } from '../ExpertAvatarGroup'
import { ExpertUserSummaryApi } from 'interfaces/types/Expert'

function formatExpertToExpertAvatarItem(
  experts?: ExpertUserSummaryApi[],
  currentUrl?: string,
): ExpertAvatarItem[] {
  return (experts || [])?.map((expert) => {
    return {
      ...expert,
      anchorProps: {
        href: `/expert/${expert?.slug}`,
        'data-event-category': 'Recommend Experts',
        'data-event-action': 'Experts Click',
        'data-event-label': `${currentUrl}${basePath}expert/${expert?.slug}`,
      },
    }
  })
}

export function useHomeExpert(props: Pick<HomeExpertProps, 'experts'>) {
  const { experts: expertsProps } = props
  const currentUrl = useCurrentUrl()
  const [experts, setExperts] = useState<ExpertAvatarItem[]>(
    formatExpertToExpertAvatarItem(expertsProps, currentUrl),
  )

  useEffect(() => {
    setExperts(formatExpertToExpertAvatarItem(expertsProps, currentUrl))
  }, [expertsProps])

  return useMemo(() => ({ experts, setExperts }), [experts])
}
